<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div class="sidebar-fix" >
      <div *ngIf="selected!=null">

        <div class="h2">{{getProductName(selected)}}</div>
        <div style="text-align:right; width:100%"><div style="position:relative;bottom:33px;right:10px">
          <button class="nrk-button" (click)="copyToClipboard(getProductLink())">Copy Product Link</button>
        </div></div>
        <br>

        <ngx-form-dropdown [disabled]="locked" title="Business Unit" [(value)]="selected.businessUnit" [options]="data.businessUnitOptions" (valueChange)=setMaterialOptions($event)></ngx-form-dropdown>
        <ngx-form-dropdown [disabled]="locked" title="Material" [value]="selected.material?._id" (valueChange)="setMaterial($event)" [options]="data.materialOptions"></ngx-form-dropdown>
        <ngx-form-text [disabled]="locked" title="Name" [(value)]="selected.name"></ngx-form-text>
        <ngx-form-text [disabled]="locked" title="Alternative BP" [(value)]="selected.alternativeBP"></ngx-form-text>
        <ngx-form-text *ngIf="isEnergy(selected)" [disabled]="locked" title="Thickness (µm)" [value]="selected.thickness" (keyUp)="thicknessChanged($event)"></ngx-form-text>
        <ngx-form-text [disabled]="locked" [multiline]="1" title="Trial Number (Offer Number)" [(value)]="selected.trial"></ngx-form-text>
        <ngx-form-dropdown [disabled]="locked" title="Status" [(value)]="selected.status" [options]="statusOptions"></ngx-form-dropdown>
        <div style="position:relative" *ngIf="this.selected.customer">
          <ngx-doc-form-filter-select [disabled]="locked" [noBorder]="true" title="Customer" [options]="data.businessOptions" [(value)]="selected.customer.id"></ngx-doc-form-filter-select>
          <div style="position:absolute;right:27px;bottom:8px">
            <ngx-doc-form-checkbox *ngIf="selected.customer?.id" [(value)]="selected.customer.checked" [disabled]="locked"></ngx-doc-form-checkbox>
          </div>
        </div>
        <div style="position:relative" *ngIf="this.selected.supplier">
          <ngx-doc-form-filter-select [disabled]="locked" [noBorder]="true" title="Supplier" [options]="data.businessOptions" [(value)]="selected.supplier.id"></ngx-doc-form-filter-select>
          <div style="position:absolute;right:27px;bottom:8px">
            <ngx-doc-form-checkbox *ngIf="selected.supplier?.id" style="padding-top:5px;" [(value)]="selected.supplier.checked" [disabled]="locked"></ngx-doc-form-checkbox>
          </div>
        </div>
        <ngx-form-text *ngIf="isEnergy(selected)" [multiline]="1" [disabled]="locked" title="Total Area Weight (g/m²)" [(value)]="$any(selected).weight"></ngx-form-text>
        <ngx-form-text *ngIf="isEnergy(selected)" [multiline]="1" [disabled]="locked"  title="Binder Content (g/m²)" [(value)]="$any(selected).binderContent"></ngx-form-text>
        <ngx-form-dropdown *ngIf="isEnergy(selected)" [disabled]="locked"  title="Accelerator Type" [(value)]="selected.accelType" [options]="accelTypeOptions"></ngx-form-dropdown>
        <ngx-form-text *ngIf="isEnergy(selected)" [multiline]="1" [disabled]="locked"  title="Accelerator Content (mg/m²)" [(value)]="$any(selected).accelContent"></ngx-form-text>
        <ngx-form-dropdown *ngIf="isEnergy(selected)" [disabled]="locked"  title="Mica Paper" [(value)]="selected.micaPaper" [options]="micaPaperOptions"></ngx-form-dropdown>
        <ngx-form-text *ngIf="isEnergy(selected)" [multiline]="1" [disabled]="locked"  title="Grammature Mica (g/m²)" [(value)]="$any(selected).grammatureMica"></ngx-form-text>
        <ngx-form-text *ngIf="isEnergy(selected)" [disabled]="locked" [multiline]="1" title="Shelf Life" [(value)]="selected.shelfLife"></ngx-form-text>

        <div class="row">
          <div class="col-md-4"><label>TDS Shelf Life From Date of Production</label></div>
          <div class="col-md-8">
            <div class="form-group">
              <div class="row mt-1">
                <div class="ml-3">20°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLife20Deg" (valueChange)="selected.shelfLife20Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
                <div class="ml-3">10°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLife10Deg" (valueChange)="selected.shelfLife10Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
                <div class="ml-3">5°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLife5Deg" (valueChange)="selected.shelfLife5Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4"><label>TDS Shelf Life From Date of Dispatch</label></div>
          <div class="col-md-8">
            <div class="form-group">
              <div class="row mt-1">
                <div class="ml-3">20°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLifeFromDispatch20Deg" (valueChange)="selected.shelfLifeFromDispatch20Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
                <div class="ml-3">10°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLifeFromDispatch10Deg" (valueChange)="selected.shelfLifeFromDispatch10Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
                <div class="ml-3">5°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLifeFromDispatch5Deg" (valueChange)="selected.shelfLifeFromDispatch5Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4"><label>Internal Minimum Shelf Life</label></div>
          <div class="col-md-8">
            <div class="form-group">
              <div class="row mt-1">
                <div class="ml-3">20°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLifeMinInternal20Deg" (valueChange)="selected.shelfLifeMinInternal20Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
                <div class="ml-3">10°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLifeMinInternal10Deg" (valueChange)="selected.shelfLifeMinInternal10Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
                <div class="ml-3">5°C: <ngx-doc-form-texfield mode="integer" [disabled]="locked" [value]="selected.shelfLifeMinInternal5Deg" (valueChange)="selected.shelfLifeMinInternal5Deg = $event === 0 ? null : $event"></ngx-doc-form-texfield> Month(s) </div>
              </div>
            </div>
          </div>
        </div>

        <ngx-form-dropdown [disabled]="locked" title="Country of Origin" [(value)]="selected.countryOfOrigin" [options]="countryOptions"></ngx-form-dropdown>

        <ngx-form-text [disabled]="locked" [multiline]="1" title="Remark" [(value)]="selected.remark"></ngx-form-text>
        <ngx-form-text [disabled]="true" title="Code" [(value)]="selected.code"></ngx-form-text>
        <div class="row">
          <div class="col-md-4"><label>Finished Products</label></div>
          <div class="col-md-8">
            <div class="form-group finished-products">
              <ng-container *ngIf="finishedProducts?.length">
                <div *ngFor="let item of finishedProducts">
                  <a [routerLink]="[]" (click)=gotoFinishedProduct(item)>
                    {{item.calcCode}} - {{removeVersionString(item.calcName)}}</a>
                </div>
              </ng-container>
              <ng-container *ngIf="!finishedProducts?.length && clonedFinishedProducts?.length">
                <ng-container *ngFor="let item of clonedFinishedProducts">
                  <!-- <div *ngIf="!item.draft">{{item.calcName}}</div> -->
                  <ngx-form-check *ngIf="!item.fp.draft" [(value)]="item.checked" [name]="item.fp.calcName"></ngx-form-check>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- ======================================================= files ================================================================== -->
        <div class="file-upload">
          <ngx-form-upload [disabled]="locked" [hideComment]="false" [hideCheckbox]="false" accept="application/pdf" class="file-upload-comp" title="TDS (Technical Datasheet)" url="/api/v1/upload" [(files)]="selected.technicalDatasheets"></ngx-form-upload>
          <br>
          <ngx-form-upload [disabled]="locked" [hideComment]="false" [hideCheckbox]="false" accept="application/pdf" class="file-upload-comp" title="Attached Files" url="/api/v1/upload" [(files)]="selected.files"></ngx-form-upload>
        </div>

        <!-- ======================================================= versions ================================================================== -->
        <br />
        <div class="row">
          <div class="col-md-4"><label>Versions</label></div>
          <div class="col-md-8">
            <div class="form-group versions">
              <div *ngFor="let item of getVersions(selected)">
                <button [ngClass]="{'nrk-doc-button': true, 'version-active': item.version == selected.version}" (click)="switchToVersion(item)">{{item.version-1}}</button>
              </div>
            </div>
          </div>
        </div>
        <br />

        <!-- ======================================================= changelog ================================================================== -->
        <div class="row" *ngIf="selected.changelog.length > 0">
          <div class="col-md-4"><label>Changelog</label></div>
          <div class="col-md-8">
            <div class="form-group">
              <ngx-changelog [abstractItem]="selected" [print]="false" [disabled]="locked"></ngx-changelog>
            </div>
          </div>
        </div>
        <br />

        <!-- <ngx-form-text [multiline]="1" title="Changelog comment" [(value)]="changelog" [disabled]="locked"></ngx-form-text> -->
        <br />
        <br />
        <br />
      </div>
    </div>

    <div class="sidebar footer" *ngIf="selected">
      <div *ngIf="!isPreview" style="display:flex;align-items:center;justify-content:center;">
        <button *ngIf="fromWizard?.productWizard" class="btn btn-md btn-default" title="Back to Base Product Overview" 
          (click)="cancel(selected)">
          <i class="ion-arrow-left-a"></i>
        </button>
        <button *ngIf="!fromWizard?.productWizard" class="btn btn-default btn-md" (click)="cancel(selected)">Close</button>
        <!-- <button *ngIf="!readOnly && (locked && canUnlock()) && isFirstVersion()" class="btn btn-primary btn-md" (click)="edit()">Edit</button> -->
        <button *ngIf="!readOnly && (locked && canUnlock())" class="btn btn-primary btn-md" (click)="edit()">Edit</button>
        <!-- <button *ngIf="!readOnly && (locked && canUnlock())" class="btn btn-primary btn-md" (click)="lock(false)">{{isFirstVersion ? 'New version' : 'Unlock'}}</button> -->
        <button *ngIf="!readOnly && !locked" class="btn btn-primary btn-md" (click)="save(selected)">Save</button>
        <button *ngIf="!readOnly && !locked && selected.draft" class="btn btn-danger btn-md" (click)="cancelDraft(selected)">Cancel Draft</button>
        <button *ngIf="!readOnly && !locked" class="btn btn-info btn-md" (click)="save(selected, true)">Save Draft</button>
        <button *ngIf="!readOnly && selected._id" class="btn btn-info btn-md" (click)="create(selected, true)">Clone</button>
        <button *ngIf="!readOnly && selected._id" class="btn btn-info btn-md" (click)="create(selected, true, true)">Clone with Finished Products</button>
        <button class="btn btn-info btn-md" (click)="isPreview=true">Download</button>
        <button *ngIf="!fromWizard?.productWizard && !readOnly && !selected.draft && canUnlock()" class="btn btn-info btn-md" (click)="newFinishedProduct(selected)">New Finished Product</button>
        <button *ngIf="fromWizard?.productWizard && !readOnly && !selected.draft && canUnlock()" class="btn btn-info btn-md" (click)="newFinishedProductWizard(selected)">New Finished Product</button>
        <!-- <button *ngIf="fromWizard?.productWizard && !readOnly && !selected.draft && canUnlock()" class="btn btn-info btn-md" (click)="genLineItemsFromFinishedProducts()" title="generate line items from base product's finished products">Gen Line Items</button> -->
        <button *ngIf="fromWizard?.productWizard && !readOnly && !selected.draft && canUnlock()" class="btn btn-info btn-md" (click)="baseProductPriceMatrix()" titile="price matrix related to base product">Prices</button>
        <button class="btn btn-default btn-md" (click)="loadData(true)" title="refresh data"><i class="ion-refresh"></i></button>
        <button *ngIf="fromWizard?.productWizard " class="btn btn-md btn-default" title="go to finished product" 
          (click)="finishedProducts?.length ? gotoFinishedProduct(finishedProducts[0]) : newFinishedProductWizard(selected)">
          <i class="ion-arrow-right-a"></i>
        </button>
      </div>
      <div *ngIf="isPreview" style="display:flex;align-items:center;justify-content:center;">
        <button class="btn btn-default btn-md" (click)="isPreview=false">Back</button>
        <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.document)">Document</button>
        <!-- <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.merged)">Merge document with attachments</button> -->
        <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipMerged)">ZIP (Document & Attachments)</button>
        <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipAttachments)">ZIP (Attachments only)</button>
        <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.document); pdfPreview(selected, downloadType.zipAttachments)">PDF + ZIP</button>
      </div>
    </div>

  </ng-sidebar>

  <div ng-sidebar-content>
    <ngx-page-container>
      <h1>{{fromWizard?.offerWizard ? 'Select ' : ''}}Base Product</h1>
      <hr>

      <!-- <ngx-search [dropdownOptions]="columnOptions" [(selectedOption)]="column" [(value)]="search"></ngx-search> -->

      <div *ngIf="!readOnly && !fromWizard" class="create">
        <button class="btn btn-primary btn-sm" (click)="create()" title="add base product">+</button>
      </div>
      <div class="status-bu">
        <div>
          <div>
            Status
            <ngx-doc-form-dropdown class="fullwidth" [options]="statusFilterOptions" [(value)]="statusFilter"></ngx-doc-form-dropdown>
          </div>
          <div>
            Business Unit
            <ngx-doc-form-dropdown class="fullwidth" [options]="buFilterOptions" [(value)]="buFilter"></ngx-doc-form-dropdown>
          </div>
        </div>
      </div>

      <div class="mx-auto"><pagination-controls (pageChange)="bpPage = $event"></pagination-controls></div>

      <table class="table table-hover">
        <thead>
        <tr>
          <th *ngFor="let col of columns; let idx = index;" class="pseudo-link" (click)="onSort(col.id)">
            {{col.name}}<span *ngIf="sort.column === col.id">&nbsp;{{sort.dir > 0 ? '▲' : '▼'}}</span></th>
          <th style="text-align:center">
            <span style="padding-right:1.5em" title="Technical datasheet">TDS</span><span>Enabled</span>
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" scope="col">
            <ngx-doc-form-texfield class="fullwidth noborder" [value]="col.search" (keyupChange)="col.search=$event">
          </ngx-doc-form-texfield></th>
          <th style="text-align: center">
            <button class="nrk-button" (click)="clearFilter()">Clear Filter</button>
          </th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filter(columns) | paginate: { itemsPerPage: 10, currentPage: bpPage }"
            [ngClass]="{ 'table-warning nrk-row-disabled': item.disabled, 'table-info': item.draft && !item.disabled, 'table-success': !item.disabled && !item.draft, 'table-template': +item.status === 5 }"
            (click)="select(item)">
              <td (click)="toggleSidebar(item)">{{productName[item._id]}}</td>
              <td (click)="toggleSidebar(item)">{{item.trial}}</td>
              <td (click)="toggleSidebar(item)">{{businessName[item.customer?.id]}}</td>
              <td (click)="toggleSidebar(item)">{{businessName[item.supplier?.id]}}</td>
              <td (click)="toggleSidebar(item)">{{materialName[mongoId(item.material)]}}</td>
              <td (click)="toggleSidebar(item)"[ngClass]="{'disabled':!isEnergy(item)}">{{!isEnergy(item) ? '' : item.weight}}</td>
              <td (click)="toggleSidebar(item)">{{item.remark}}</td>
              <td (click)="toggleSidebar(item)">{{item.code}}</td>
              <td (click)="toggleSidebar(item)">{{item.updatedAt | date : 'yyyy-MM-dd' }}</td>
              <td>
                <div class="buttons">
                  <div>
                    <button *ngIf="isTDS[item._id]" class="btn btn-default btn-md" (click)="downloadTDS(item)" title="Download technical datasheet"><i class="ion-arrow-down-a"></i></button>
                  </div>
                  <div *ngIf="!readOnly">
                    <!-- <ui-switch color="#308040A0" [(ngModel)]="!item.disabled" (change)="toggleDisable(item)" title="Enable / disable product"></ui-switch> -->
                    <form-ui-switch ngDefaultControl [value]="!item.disabled" (valueChange)="toggleDisable(item)" title="Enable / disable product"></form-ui-switch>
                  </div>
                </div>
              </td>
          </tr>
        </tbody>
      </table>
 
    </ngx-page-container>
  </div>
</ng-sidebar-container>

<div class="nrk-wizard-footer text-center" *ngIf="fromWizard?.productWizard && fromWizard?.compilation?.type === typeData.get('TOF').id">
  <button *ngIf="fromWizard?.productWizard" class="btn btn-md btn-default" title="add base product template" (click)="create()">
      Add new base product template&nbsp;&nbsp;<i class="ion-arrow-right-a"></i>
  </button>
  <button *ngIf="fromWizard?.productWizard" class="btn btn-md btn-default" title="go to finished products" (click)="newFinishedProductWizard(null)">
    Go to finished products&nbsp;&nbsp;<i class="ion-arrow-right-a"></i>
  </button>
</div>

<div class="nrk-wizard-footer text-center" *ngIf="fromWizard?.productWizard && fromWizard?.compilation?.type !== typeData.get('TOF').id">
  <button *ngIf="fromWizard?.productWizard" class="btn btn-md btn-default" title="add base product" (click)="create()">
      Add new base product&nbsp;&nbsp;<i class="ion-arrow-right-a"></i>
  </button>
  <button *ngIf="fromWizard?.productWizard" class="btn btn-md btn-default" title="go to finished products" (click)="newFinishedProductWizard(null)">
    Go to finished products&nbsp;&nbsp;<i class="ion-arrow-right-a"></i>
  </button>
</div>
